import { render, staticRenderFns } from "./BrandInfomation.vue?vue&type=template&id=5c5eb62b&scoped=true"
import script from "./BrandInfomation.vue?vue&type=script&lang=js"
export * from "./BrandInfomation.vue?vue&type=script&lang=js"
import style0 from "./BrandInfomation.vue?vue&type=style&index=0&id=5c5eb62b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c5eb62b",
  null
  
)

export default component.exports